<template>
  <div class="row">
    <div class="col-12 d-flex justify-content-between align-items-center mt-2">
      <h4 class="text-center mr-3 m-0">
        {{ $t('PRODUCTS.TITLE.PRODUCT_REVIEWS') }}
      </h4>
      <div>
        <HMButton
          color="brand"
          @click="reviewProduct"
          v-if="canReview && !reviewSubmitInProgress"
        >
          {{ $t('PRODUCTS.BUTTON.REVIEW_PRODUCT') }}
        </HMButton>
      </div>
    </div>
    <div
      class="col-12 pt-2"
      v-infinite-scroll="loadMoreReviews"
      infinite-scroll-disabled="canLoadMore"
      infinite-scroll-distance="10"
    >
      <ProductReviewCard
        v-for="review in reviews"
        :key="review.id"
        :review="review"
        :primaryColor="currentStudio.primary_color"
        :iconType="currentStudio.rating_icon_type"
      />
    </div>
    <div class="col-12 pt-3">
      <HMAlertInfo
        status="outline"
        :showIcon="false"
        v-if="
          isLoggedIn && !product.number_of_reviews && !reviewSubmitInProgress
        "
      >
        {{ $t('PRODUCTS.NOTIFICATIONS.NO_REVIEWS_YET_BE_THE_FIRST_TO_LEAVE') }}
      </HMAlertInfo>
      <HMAlertInfo
        status="outline"
        :showIcon="false"
        v-if="!isLoggedIn && !product.number_of_reviews"
      >
        {{ $t('PRODUCTS.NOTIFICATIONS.NO_REVIEWS_YET') }}
      </HMAlertInfo>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { getStudioURL } from '@/web/router/custom-domain-utils';
import ProductReviewsModal from '@/web/components/products/ProductReviewsModal.vue';
import ProductReviewCard from '@/web/components/products/ProductReviewCard.vue';

export default Vue.extend({
  name: 'StudioProductReviews',
  components: { ProductReviewCard },
  data() {
    return {
      inProggres: false,
      reviews: [],
      page: 0,
      nextPage: true,
      reviewSubmitInProgress: false,
    };
  },
  computed: {
    ...mapGetters({
      product: 'product/product',
      user: 'user/user',
      studentId: 'user/studentId',
      canViewProductContent: 'product/canViewProductContent',
      currentStudio: 'studio/currentStudio',
      isLoggedIn: 'user/isLoggedIn',
    }),
    studioURL() {
      return getStudioURL(this.$route);
    },
    query() {
      return {
        productId: this.product.id,
        studioURL: this.studioURL,
      };
    },
    canReview() {
      return (
        this.isLoggedIn &&
        this.currentStudio.product_reviews_enabled &&
        !this.product.reviewed &&
        this.product?.purchased
      );
    },
    canLoadMore() {
      return !this.nextPage && this.inProggres;
    },
  },
  methods: {
    async onReviewSubmitted() {
      this.reviewSubmitInProgress = true;
      this.reviews = [];
      this.page = 0;
      this.nextPage = true;
      await Promise.all([
        this.loadMoreReviews(),
        this.$store.dispatch('product/refreshProductDetail', {
          studioURL: this.studioURL,
          productId: this.product.id,
        }),
      ]);
      this.reviewSubmitInProgress = false;
    },
    async loadMoreReviews() {
      if (!this.nextPage) return;
      this.page++;
      this.inProggres = true;
      const data = await this.$store.dispatch(
        'product/getStudentProductsReviews',
        {
          studioURL: this.studioURL,
          productId: this.product.id,
          page: this.page,
        }
      );
      if (data.next === null) {
        this.nextPage = false;
      }
      const pageReviws = data.results;
      this.reviews = [...this.reviews, ...pageReviws];
      this.inProggres = false;
    },
    reviewProduct() {
      this.$modal.show(
        ProductReviewsModal,
        {
          productId: this.product.id,
          studioURL: this.studioURL,
          initialRating: 5,
        },
        {},
        {
          'review-submitted': this.onReviewSubmitted,
        }
      );
    },
  },
});
</script>

<style scoped></style>
